import { useState, useEffect } from 'react'
import { getKyousouApiClient, handleError, ApiErrorResponse } from '../../../../services/network'
import { useSnackBar } from '../../../../providers/snack_bar_provider'
import { SlideThreeC } from './types'

export const useThreeCDetail = (businessIdeaId: string) => {
  const apiClient = getKyousouApiClient()
  const { showSnackBar } = useSnackBar()
  const [threeC, setThreeC] = useState<SlideThreeC | null>(null)
  const [isThreeCLoading, setIsThreeCLoading] = useState(true)

  useEffect(() => {
    const threeCDetail = async () => {
      if (!businessIdeaId) return

      setIsThreeCLoading(true)

      try {
        const response = await apiClient.business.slideThreecDetailList(businessIdeaId)
        setThreeC(response.data.threeC)
      } catch (e) {
        console.error('3C分析の取得に失敗しました:', e)
        handleError(e as ApiErrorResponse, showSnackBar)
        setThreeC(null)
      } finally {
        setIsThreeCLoading(false)
      }
    }

    threeCDetail()
  }, [businessIdeaId])

  return {
    threeC,
    setThreeC,
    isThreeCLoading,
    setIsThreeCLoading,
  }
}
